import Vue from "vue";
import Router from "vue-router";
import { Me } from "@/class/me";
import HelloWorld from "@/pages/HelloWorld";
import ListOrdens from "@/pages/ListOrdens";
import VerOrdem from "@/pages/VerOrdem";
import BuscarLatLong from "@/pages/BuscarLatLong";
import FinalizarInternet from "@/pages/FinalizarInternet";
import BuscarCaixasGoogleMaps from "@/pages/BuscarCaixasGoogleMaps";
import VerCaixasGoogleMaps from "@/pages/VerCaixasGoogleMaps";
import Finalizar from "@/pages/Finalizar";
import Eventos from "@/pages/Eventos";
import Login from "@/pages/Login";
import ProblemasSinal from "@/pages/caixas/ProblemasSinal";
import ViewCaixaPacpon from "@/pages/caixas/ViewCaixaPacpon";
import ViewCaixaCto from "@/pages/caixas/ViewCaixaCto";
import CaixasOffline from "@/pages/caixas/CaixasOffline";
import OnuUnregistered from "@/pages/caixas/OnuUnregistered";
import Registrar from "@/pages/caixas/Registrar";
import CadastrarCaixa from "@/pages/caixas/CadastrarCaixa";
import CadastrarCaixa2 from "@/pages/caixas/CadastrarCaixa2";
import SubstituirCaixa from "@/pages/caixas/SubstituirCaixa";
import SubstituirCaixa2 from "@/pages/caixas/SubstituirCaixa2";
import ListCtos from "@/pages/caixas/ListCtos";

Vue.use(Router);

let checkAuth = (to, from, next) => {
    Me
        .get()
        .then((me) => {
            if (me) {
                return next();
            } else {
                return next({ path: "/login" });
            }
        });
};

export default new Router({
    routes: [
        {
            path: "/",
            name: "Home",
            component: HelloWorld,
            beforeEnter: checkAuth
        },
        {
            path: "/list-ordens",
            name: "ListOrdens",
            component: ListOrdens,
            beforeEnter: checkAuth
        },
        {
            path: "/list-ctos",
            name: "ListCtos",
            component: ListCtos,
            beforeEnter: checkAuth
        },
        {
            path: "/onus-unregistered",
            name: "OnuUnregistered",
            component: OnuUnregistered,
            beforeEnter: checkAuth
        },
        {
            path: "/substituir/caixa",
            name: "SubstituirCaixa",
            component: SubstituirCaixa,
            beforeEnter: checkAuth
        },
        {
            path: "/substituir/caixa/:mac",
            name: "SubstituirCaixa2",
            component: SubstituirCaixa2,
            beforeEnter: checkAuth
        },
        {
            path: "/onu-registrar/:mac",
            name: "Registrar",
            component: Registrar,
            beforeEnter: checkAuth
        },
        {
            path: "/problemas/sinal",
            name: "ProblemasSinal",
            component: ProblemasSinal,
            beforeEnter: checkAuth
        },
        {
            path: "/caixas/offline",
            name: "CaixasOffline",
            component: CaixasOffline,
            beforeEnter: checkAuth
        },
        {
            path: "/cadastrar/caixa",
            name: "CadastrarCaixa",
            component: CadastrarCaixa,
            beforeEnter: checkAuth
        },
        {
            path: "/cadastrar/caixa/:lat/:lng",
            name: "CadastrarCaixa2",
            component: CadastrarCaixa2,
            beforeEnter: checkAuth
        },
        {
            path: "/caixa/pacpon/:id",
            name: "ViewCaixaPacpon",
            component: ViewCaixaPacpon,
            beforeEnter: checkAuth
        },
        {
            path: "/caixa/cto/:id",
            name: "ViewCaixaCto",
            component: ViewCaixaCto,
            beforeEnter: checkAuth
        },
        {
            path: "/ver-ordem/:id",
            name: "VerOrdem",
            component: VerOrdem,
            beforeEnter: checkAuth
        },
        {
            path: "/latlong/:id",
            name: "LatLong",
            component: BuscarLatLong,
            beforeEnter: checkAuth
        },
        {
            path: "/eventos/:id",
            name: "Eventos",
            component: Eventos,
            beforeEnter: checkAuth
        },
        {
            path: "/finalizar/internet/:id",
            name: "FinalizarInternet",
            component: FinalizarInternet,
            beforeEnter: checkAuth
        },
        {
            path: "/buscar-caixas-maps/:id",
            name: "BuscarCaixasGoogleMaps",
            component: BuscarCaixasGoogleMaps,
            beforeEnter: checkAuth
        },
        {
            path: "/ver-caixas-maps",
            name: "VerCaixasGoogleMaps",
            component: VerCaixasGoogleMaps,
            beforeEnter: checkAuth
        },
        {
            path: "/finalizar/:id",
            name: "Finalizar",
            component: Finalizar,
            beforeEnter: checkAuth
        },
        {
            path: "/login",
            name: "Login",
            component: Login
        }
    ]
})
